import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//E-commerce
import ecommerce from "./e-commerce/reducer"

//Calendar
import calendar from "./calendar/reducer"

//chat
import chat from "./chat/reducer"


//invoices
import invoices from "./invoices/reducer"


//tasks
import tasks from "./tasks/reducer"

//contacts
import contacts from "./contacts/reducer"

//mails
import mails from "./mails/reducer";
import customers from "./customers/reducer";

//Dashboard
import Dashboard from "./dashboard/reducer";

//Production
import production from "./production/reducer";

//Sections
import sections from "./sections/reducer";

//Company
import company from "./company/reducer";

//Invoice Companies
import invoiceCompanies from "./invoiceCompanies/reducer";

//Workflow
import workflow from "./workflow/reducer";

//Realtime Chat
import realtimeChat from "./realtimeChat/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  calendar,
  chat,
  mails,
  invoices,

  tasks,
  contacts,
  Dashboard,
  customers,
  production,
  sections,
  company,
  invoiceCompanies,
  workflow,
  realtimeChat,
})

export default rootReducer
